import { getIconFromRegistry } from '@unifyapps/icons/utils/getIconFromRegistry';

function UIIcon({ name, ...props }: { name: string; [key: string]: unknown }) {
  const Icon = getIconFromRegistry(name);

  return Icon ? <Icon {...props} /> : null;
}

export default UIIcon;
